import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/payment/callback")({
  component: RouteComponent,
});

const ALLOWED_DOMAINS = ["stripe.com"];

// URL 검증 함수
const isValidRedirectUrl = (url: string) => {
  try {
    // 상대 경로 허용
    if (url.startsWith("/")) {
      return true;
    }

    // 절대 URL 검증
    const urlObj = new URL(url);

    // 허용된 프로토콜만 허용
    if (!["https:"].includes(urlObj.protocol)) {
      return false;
    }

    // 허용된 도메인 확인
    const hostname = urlObj.hostname;
    return ALLOWED_DOMAINS.some((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
  } catch (error) {
    // URL 파싱 오류 시 false 반환
    return false;
  }
};

function RouteComponent() {
  const { redirectUrl } = useSearch({
    strict: false,
    select: (params) => ({ redirectUrl: "redirectUrl" in params ? (params.redirectUrl as string) : undefined }),
  });

  useEffect(() => {
    if (redirectUrl) {
      if (isValidRedirectUrl(redirectUrl)) {
        window.location.href = redirectUrl;
      }
    }
  }, [redirectUrl]);

  return (
    <div className="flex items-center justify-center w-full h-screen">
      <div
        className="animate-spin h-8 w-8 rounded-full border-2"
        style={{
          border: "2px solid transparent",
          background:
            "linear-gradient(white, white) padding-box, linear-gradient(to right, #e5e7eb, #9ca3af) border-box",
        }}
      />
    </div>
  );
}
